import * as flights from '../../flights';

export class FlightKindFilterItem {
    checked: boolean;
    name: string;

    constructor(checked: boolean, name: string) {
        this.checked = checked;
        this.name = name;
    }
}

export class FlightKindFilter {
    items: FlightKindFilterItem[] = [];

    constructor(flights: flights.FlightModel[]) {
        const newItems: FlightKindFilterItem[] = [];
        const keys: string[] = [];

        flights.forEach((flight) => {
            if (keys.indexOf(flight.flightKind) < 0) {
                newItems.push(new FlightKindFilterItem(false, flight.flightKind));
                keys.push(flight.flightKind);
            }
        });

        newItems.sort((a, b) => {
            return a.name == b.name ? 0 : (a.name > b.name ? 1 : -1);
        });

        if (newItems.length > 1) {
            this.items = newItems;
        }
    }

    get touched(): boolean {
        let result = false;

        if (this.getCheckedItemIds().length > 0) {
            result = true;
        }

        return result;
    }

    clear() {
        this.items.forEach((item: FlightKindFilterItem) => {
            item.checked = false;
        });
    }

    check(flight: flights.FlightModel): boolean {
        const checkedItems = this.getCheckedItemIds();

        if (checkedItems.length > 0 && checkedItems.indexOf(flight.flightKind) < 0) {
            return false;
        }

        return true;
    }

    private getCheckedItemIds(): string[] {
        const result: string[] = [];

        this.items.forEach((item: FlightKindFilterItem) => {
            if (item.checked) {
                result.push(item.name);
            }
        });

        return result;
    }
}
